import { IconLineEdit, IconLinePlus } from "@kalodata/kds-design-icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export interface PlusCaptionProps {
  value?: string;
  className?: string;
}

export const PlusCaption = (props: PlusCaptionProps) => {
  const { className, value } = props;
  const { t } = useTranslation();
  const isEmpty = !value || value.trim() === "";

  return isEmpty ? (
    <div
      className={twMerge(
        "flex items-center justify-center gap-[6px] px-[10px] py-[6px] cursor-pointer select-none",
        className,
      )}
    >
      <IconLinePlus size={16} />
      <div className="text-center text-[14px] font-medium leading-[16px]">{t("Caption")}</div>
    </div>
  ) : (
    <Tooltip title={value} placement="top" classNames={{ root: "kds-caption-tooltip" }}>
      <div
        className={twMerge(
          "flex items-center justify-center gap-[12px] py-[4px] cursor-pointer select-none",
          className,
        )}
      >
        <div className="truncate text-center text-[14px] font-normal tracking-normal text-kds-fg-soft">{value}</div>
        <IconLineEdit size={16} />
      </div>
    </Tooltip>
  );
};
